<template>
    <div class="base-trumpet-add" :class="{'trumpetadd-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">增加小号</div>
            <div>
                <input class="val" type="text" maxlength="24" placeholder="请输入小号名（不得大于24个字符）" v-model="name" />
            </div>
            <div class="btn">
                <div class="item" @click="onOut">取消</div>
                <div class="item" @click="addTrumpet">确定</div>
            </div>
            <transition name="component-fade" mode="out-in">
                <TheTips :msg='msg' v-if="msg" />
            </transition>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                name: '',
                accountData: {},
                h5LoginData:{}
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childAdd', false)
            },
            // 添加小号
            addTrumpet () {
                if (this.name.replace(/\s*/g, "")) {
                    let options = {
                        uid: this.accountData.uid,
                        nick_name: this.name,
                        appid: this.h5LoginData.appid, //渠道ID
                        system: this.config.system, //系统
                        machine_code: this.h5LoginData.machine_code //设备号
                    }
                    options.sign = this.util.getSign(options, this.h5LoginData.appkey)
                    this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=add_appuid', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            this.msg = '添加成功'
                            setTimeout(() => {
                                this.msg = null
                                this.$emit('childAdd', false)
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                }
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-trumpet-add {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                outline: none;
            }
            .val:last-child {
                margin-bottom: 0;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .trumpetadd-sp {
        .content {
            // width: 1527px;
            width: 85%;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin-bottom: 54px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    // width: 627px;
                    width: 47%;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>